import Cookies from "universal-cookie";
import axios from "axios";

export const logIn = (loginData) => {
  return new Promise((resolve, reject) => {
    if (!loginData.email)
      reject({ type: "error", message: "Por favor, complete el campo email." });
    if (!loginData.pass)
      reject({
        type: "error",
        message: "Por favor, complete el campo contraseña.",
      });

    axios
      .post(`${process.env.REACT_APP_BASEURL}/session/login`, {
        email: loginData.email,
        pass: loginData.pass,
      })
      .then(async (res) => {
        await setCookie(res.data.token);
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

const setCookie = async (token) => {
  const cookies = new Cookies();
  await cookies.set("jes", token, { path: "/" });
};

export const logOut = async () => {
  const cookies = new Cookies();
  await cookies.remove("jes", { path: "/" });
  window.location.replace("/login");
};
